<template>
  <section class="content">
    <!-- Default box -->
    <div class="col-md-2"></div>
    <div class="col-md-8">
    <div class="box" style="font-size: 16px;">
      <div class="box-header with-border tc" style="padding: none;">
        <h1 class="box-title" style="font-size:21px">Screenit- FAQs(General)</h1>
      </div>
      <div class="box-body" style="height: 100%;min-height: 700px;">
        <div class="col-md-12"><br>
        <dl>
        <dt>What is Screenit?</dt>
        <dd>Screenit is a platform which facilitates Enterprises/Organizations to
utilize the proficiency of a technical expert to conduct interviews for their hiring needs.</dd><br>
        <dt>How can I access this application? </dt>
        <dd>Screenit offers web portal support for Organizations and Mobile
applications( available in Google Play store/ Apple iOS) for Interviewers. </dd><br>
        <dt>Who can be part of Screenit? </dt>
        <dd>Organizations in need of best technical fit can make use of Screenit
for faster and smarter hiring solutions. Individuals with deep domain technical skills / knowledge can utilize
their ease time by interviewing candidates through our platform and
earn extra income. </dd>
      </dl>
        <div class="tc"><h1 style="font-size:21px">Screenit- FAQs(Interviewers) </h1></div><br>
        <dl>
        <dt>Why should I be part of Screenit?</dt>
        <dd>Screenit will help you earn compensation in your free time, by
utilizing your hidden potential of being an Interviewer.</dd>
        <ul>
          <li>Part of next-gen hiring tool </li>
          <li>Flexible Interview Schedule</li>
          <li>Automated process for Interviewing</li>
          <li>Maintaining Strict Privacy Policies </li>
        </ul><br>
        <dt>How can I be part of Screenit? </dt>
        <dd>Screenit is a user-friendly platform which allows you to be a part of
the team by simple steps </dd>
        <ul>
          <li>Register </li>
          <li>Specify your skills </li>
          <li>Complete the skill assessment test </li>
          <li>Specify your availability for conducting interviews </li>
          <li>Complete Interviews </li>
          <li>Get Paid </li>
        </ul><br>
        <dt>Do I have to be a Screenit employee? </dt>
        <dd>No, Screenit drives on freelancing model and you can conduct
interview at your leisure time. Apart from your primary work you
can tap on extra bucks!! </dd><br>
        <dt>Who is eligible to become an Interviewer?  </dt>
        <dd>Subject Matter Expert with one or more domain knowledge will be
eligible to be an Interviewer. Based on your technical skillset, a
quick online assessment will be conducted.  </dd><br>
        <dt>How do I Sign up for Screenit?  </dt>
        <dd>Simple two step procedure, </dd><br>
        <ol>
          <li>Enter your Name & E-mail ID  </li>
          <li>Enter your Mobile number </li>
          <li>Set Password and your all set to go! </li>
          <li>Facilisis in pretium nisl aliquet</li>
        </ol><br>
        <dt>What is the technical skill self-rating?  </dt>
        <dd>Your technical skill is the key factor on the Screenit platform. You will
have to rate your skills on a scale of 1 to 5, for the system to
evaluate. </dd><br>
        <dt>Why is introduction video required? </dt>
        <dd>Introduction video helps the organization to know about your
technical skills, related work experience and inter-personal skills
and also helps the organization to generate interest towards your
profile.  </dd><br>
        <dt>Is it mandatory to complete my profile? </dt>
        <dd>Yes! Completing more than 80% of the profile will qualify you to be
on the hot spot in the Interview panel.</dd><br>
        <dt>Where can I set my availability (Date/Time) to conduct
Interviews? </dt>
        <dd>Do follow these simple steps to add your availability </dd><br>
        <ul>
          <li>Click on Availability tab  </li>
          <li>Click on Availability tab  </li>
          <li>Click Add availability button </li>
        </ul><br>
        <dt>Is that mandatory to mark my availability (Date / Time)? </dt>
        <dd>Yes, it is essential to mark your availability though it can be
changed under uncertain times. Scheduling of interview can happen
only if availability is marked. </dd><br>
      </dl>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    </div>
    <div class="col-md-2"></div>
    <!-- /.box -->
  </section>
</template>

<script>
export default {
  name: 'tabs-card',
  data () {
    return {
      head_name: ''
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
</style>>
